import { EditIcon } from "@/constant/imagePath";
import IconButton from "..";

const EditButton = ({
  icon = EditIcon,
  borderColor = "#E80E57",
  fromColor = "#FF6060",
  toColor = "#EC1060",
  onClick = null,
  tooltipText = "Edit",
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default EditButton;
